export default __webpack_public_path__ + "static/media/micphone.b6461d2f.svg";